import T, { t } from '../../../common/components/T';
import GridComponent from '../../grid/GridComponent/GridComponent';
import Plug from '../../plug/Plug/Plug';
import Skeleton from '../../plug/Skeleton/Skeleton';
import { transformSearchUserData } from '../initData';
import plugImg from '../../../public/src/img/plugs/list_is_empty_gt.svg';
import { useContext } from 'react';
import { UserProfileContext } from '../../../common/utils/getContext';

const RenderData = ({
    userTableData,
    screenWidth,
    gridHandlers,
    gridConfig,
    thead,
    transformSearchData,
    translates,
    fastSearch
}) => {
    const { officePage } = useContext(UserProfileContext);

    const stylesTableWrapper = {
        table: screenWidth ? {} : { minWidth: '686px' }
    };
    const dataThead = thead || {
        data: [
            {
                title: t('SearchWindow-Login-v1', 'ФИО, ID', 'widget', translates, 'searchWindow'),
                type: 'login',
                name: 'username'
            },
            {
                title: t('SearchWindow-Rang', 'Квалификация', 'widget', translates, 'searchWindow'),
                type: 'rang',
                name: 'rang',
                align: 'left'
            },
            {
                name: 'contacts',
                title: t('SearchWindow-Contacts', 'Контакты', 'widget', translates, 'searchWindow'),
                type: 'contacts',
                align: 'center'
            }
        ]
    };
    return (
        <div
            style={{
                paddingBottom: '32px',
                overflow: 'hidden'
            }}
        >
            {!!userTableData?.data?.length ? (
                <GridComponent
                    fullScreen={gridConfig?.hasOwnProperty('fullScreen') ? gridConfig?.fullScreen : true}
                    sticky={true}
                    viewThead={dataThead}
                    viewData={userTableData}
                    gridName='userSearch'
                    convertData={transformSearchData || transformSearchUserData}
                    handlers={gridHandlers}
                    variant={2}
                    maxGridHeight={474}
                    gridStyles={{
                        ...(gridConfig || {}),
                        tableWrapper: stylesTableWrapper,
                        td: {
                            // usernameFIO: {
                            //     p: {
                            //         maxWidth: ' 400px',
                            //         whiteSpace: ' break-spaces'
                            //     }
                            // },
                            ...(gridConfig?.td || {})
                        }
                    }}
                />
            ) : fastSearch && officePage ? (
                <Plug plugImg={plugImg} plugTitle={<T textName='use_filters' defaultStr='Воспользуйтесь фильтром' />} />
            ) : (
                <div
                    style={
                        screenWidth
                            ? {
                                  textAlign: 'center',
                                  background: 'var(--greyTransparentHalfColor)',
                                  borderRadius: '8px',
                                  padding: '16px'
                              }
                            : {
                                  background: 'var(--greyTransparentHalfColor)',
                                  borderRadius: '8px',
                                  padding: '16px'
                              }
                    }
                >
                    <p>
                        {fastSearch ? (
                            <T textName='use_filters' defaultStr='Воспользуйтесь фильтром' />
                        ) : (
                            <T textName='gridNoData' defaultStr='Нет данных' page='all' />
                        )}
                    </p>
                </div>
            )}
        </div>
    );
};

const UserTable = ({
    userTableData,
    screenWidth,
    gridHandlers,
    gridConfig,
    thead,
    transformSearchData,
    translates,
    fastSearch
}) => {
    return (
        <Skeleton
            elements={[
                {
                    type: 'table',
                    size: {
                        rows: 10,
                        columns: 4
                    }
                }
            ]}
            Component={RenderData}
            wait={Boolean(userTableData) || Boolean(fastSearch)}
            componentProps={{
                userTableData,
                screenWidth,
                gridHandlers,
                gridConfig,
                thead,
                transformSearchData,
                translates,
                fastSearch
            }}
        />
    );
};

export default UserTable;
